// Plausible analytics helper — domain is configurable via /api/config (admin editable)
let PLAUSIBLE_DOMAIN = "";

export const setPlausibleDomain = (d) => {
  PLAUSIBLE_DOMAIN = d || "";
  if (!d || document.getElementById("plausible-script")) return;
  const s = document.createElement("script");
  s.id = "plausible-script";
  s.defer = true;
  s.setAttribute("data-domain", d);
  s.src = "https://plausible.io/js/script.js";
  document.head.appendChild(s);
  window.plausible = window.plausible || function () {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
};

export const track = (event, props) => {
  try {
    if (window.plausible) window.plausible(event, props ? { props } : undefined);
    console.debug("[analytics]", event, props || {});
  } catch (err) {
    console.debug("[analytics] track failed", err);
  }
};
